import React from "react";
import { Link } from "react-router-dom";
import "../assets/css/styles.css";
import home_delivery from "../assets/images/home_delivery.png";
import subscription_boxes from "../assets/images/subscription_boxes.png";
import custom_orders from "../assets/images/custom_orders.png";
import { ArrowRight } from "../components/Icons";

const SERVICES = [
  {
    image: home_delivery,
    title: "Home Delivery",
    body: "Seamless delivery of farm-fresh produce right to your doorstep, saving you time and effort.",
    to: "/order-now",
    cta: "See open campaigns",
  },
  {
    image: subscription_boxes,
    title: "Subscription Boxes",
    body: "Curated boxes of organic fruits and vegetables on a rhythm that fits your family's needs.",
    to: "/order-now",
    cta: "Start a box",
  },
  {
    image: custom_orders,
    title: "Custom Orders",
    body: "Build your perfect farm box by handpicking the seasonal produce and cuts you love.",
    to: "/order-now",
    cta: "Build your box",
  },
];

const Services = () => {
  return (
    <section id="services" className="section section--surface services">
      <div className="container">
        <div className="section-head" data-reveal>
          <span className="eyebrow">Our services</span>
          <h2>Three simple ways to eat closer to the source</h2>
          <p>Pick the rhythm that suits your household — we handle the rest.</p>
        </div>

        <div className="service-grid">
          {SERVICES.map((service, index) => (
            <article
              className="service-card"
              key={service.title}
              data-reveal
              style={{ "--reveal-delay": `${index * 90}ms` }}
            >
              <div className="service-media">
                <img src={service.image} alt={service.title} loading="lazy" />
              </div>
              <div className="service-body">
                <h3>{service.title}</h3>
                <p>{service.body}</p>
                <Link to={service.to} className="service-link">
                  {service.cta}
                  <ArrowRight />
                </Link>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
